import React, { createRef } from 'react'
import { createRoot } from 'react-dom/client'
import { PingResultSnackbar } from './PingResultSnackbar'
import { flushSync } from 'react-dom'

let roots = {}
let containers = {}
let pingRefs = {}

let pingSnackbars = []
// Cada elemento tiene esta estructura:
// {
//   ip: "10.0.23.153",
//   root: ReactDOMRoot,
//   container: HTMLDivElement,
//   pingRef: React.RefObject
// }

//equivalente a swal.fire 
export const showPingSnackbar = ({ name, ip, onFinalize }) => {
  closePingSnackbar() // Cierra cualquier snackbar anterior

  //Crea un div en el DOM, va a parte del resto de react
  const container = document.createElement('div')
  container.id = `pingSnackbarContainer-${ip}`
  document.body.appendChild(container)

  //crea la ref para actualizar el mensaje del ping desde fuera
  const pingRef = createRef()


  //para que react renderice
  const root = createRoot(container)
  pingSnackbars.push({ ip, root, container, pingRef, onFinalize })
  const index = pingSnackbars.length - 1


  flushSync(() => {
    root.render(
      <PingResultSnackbar
        ref={pingRef}
        name={name}
        ip={ip}
        index={index}
        onFinalize={() => {
          onFinalize?.()
          closePingSnackbar(ip)
        }}
      />
    )
  })
}

//Actualiza el mensaje del Snackbar con ese ip, si existe
export const updatePingSnackbar = (ip, message) => {
  //busca el snackbar correspondiente al ip
  const snackbarToUpdate = pingSnackbars.find(element => element.ip === ip)
  //si existe ese elemento y su ref se actualiza el mensaje
  if (snackbarToUpdate?.pingRef.current) {
    snackbarToUpdate.pingRef.current.updateMessage(message)
  }
}

// Cierra el Snackbar 
export const closePingSnackbar = (ip) => {
  //busca el snackbar correspondiente al ip
  const snackbarToClose = pingSnackbars.find(element => element.ip === ip)
  //si no se encuentra el snackbar, no hace nada
  if (!snackbarToClose) return

  if (snackbarToClose) {
    snackbarToClose.root.unmount()
    snackbarToClose.container.remove()
    pingSnackbars = pingSnackbars.filter(element => element.ip !== ip)
  }


  // recalcula el indice de los restantes para mantener el orden
  pingSnackbars.forEach((s, i) => {
    if (s.pingRef?.current) {
      s.pingRef.current.updateIndex(i)
    }
  })
}

export const closeAllPingSnackbars = () => {
  // Llama a onFinalize de cada uno antes de cerrar
  pingSnackbars.forEach(s => s.onFinalize?.())

  pingSnackbars.forEach(s => {
    s.root.unmount()
    s.container.remove()
  })
  pingSnackbars = []
}
